<template>
  <div class="signDetailList">
    <div>
      <span class="itemLabel">合同名称：</span>
      {{detail.info.name}}
    </div>
    <div>
      <span class="itemLabel">合同编号：</span>
      {{detail.info.code}}
    </div>
    <div>
      <span class="itemLabel">发起签约时间：</span>
      {{detail.info.signStartTime}}
    </div>
    <div>
      <span class="itemLabel">签署截止日期：</span>
      {{detail.info.signDeadlineDate.slice(0,10)}}
    </div>
    <div>
      <span class="itemLabel" v-if="detail.info.startDate">合同有效期限：</span>
      <span
        class="firstContent"
        v-if="detail.info.startDate"
      >{{detail.info.startDate.slice(0,10) }}&nbsp;至&nbsp;{{detail.info.endDate.slice(0,10)}}</span>

      <span class="itemLabel" v-if="!detail.info.startDate">签署方式：</span>
      <span class="firstContent" v-if="detail.info.orderType == 0&&!detail.info.startDate">无序</span>
      <span class="firstContent" v-if="detail.info.orderType == 1&&!detail.info.startDate">顺序</span>

      <span class="itemLabel" style="width:50px">发起方：</span>
      <span>{{detail.contractUser.name}}</span>
    </div>
    <div>
      <span class="itemLabel" v-if="detail.info.startDate">签署方式：</span>
      <span class="firstContent" v-if="detail.info.orderType == 0&&detail.info.startDate">无序</span>
      <span class="firstContent" v-if="detail.info.orderType == 1&&detail.info.startDate">顺序</span>
      <span class="itemLabel" :style="detail.info.startDate?'width:50px':''">签署方：</span>
      <span
        class="moreNameSign"
        v-for="(item,index) in detail.signatoryList"
        :key="index"
      >{{item.name}}</span>
    </div>
    <div class="signDetailMenu">
      <ul>
        <li @click="selectContract">
          <img class="hover" src="@image/personalSignDetail/Circlereach_icon_hov.png">
          <img class="normal" src="@image/personalSignDetail/Circlereach_icon_nor.png">
          查看合同
        </li>
        <li v-if="detail.info.signStatus == 2" @click="selectCre">
          <img class="hover" src="@image/personalSignDetail/bigFaceHov.png">
          <img class="normal" src="@image/personalSignDetail/bigFaceNor.png">
          查看证书
        </li>
        <li v-if="(detail.info.type == 2 && detail.info.signStatus == 2 && getUserInfo.currentUserId != detail.contractUser.userId ) ||  (detail.info.type == 4 && detail.info.mySignStatus == 2 && detail.info.signatoryRoleCode == 'DR')" @click="addNotrats()">
          <img class="normal" src="@image/personalSignDetail/addHov.png">
          <img class="hover" src="@image/personalSignDetail/addNor.png">
          申请公证
        </li>
        <!-- <li v-if="detail.info.signStatus == 2" @click="addFn(1)">
          <img class="hover" src="@image/personalSignDetail/sifaHov.png">
          <img class="normal" src="@image/personalSignDetail/sifaNor.png">
          司法鉴定
        </li>
        <li v-if="detail.info.signStatus == 2" @click="addFn(0)">
          <img class="normal" src="@image/personalSignDetail/addHov.png">
          <img class="hover" src="@image/personalSignDetail/addNor.png">申请律师服务
        </li> -->
        <li v-if="judgeRevoke()" @click="showReject">
          <img class="hover" src="@image/personalSignDetail/returnNor.png">
          <img class="normal" src="@image/personalSignDetail/returnHover.png">撤销合同
        </li>
      </ul>
    </div>
    <div class="completeFlag" v-if="detail.info.signStatus == 2"></div>
    <Dialog
      :visible="contractCancelShow"
      :dialogTitle="'撤销合同'"
      :width="'400px'"
      @closeDialog="closeDialog('contractCancelShow')"
    >
      <div class="signDetailDialogWithButton" slot="dialog">
        <div class="authDscp">
          <p>是否要撤销这份合同？</p>
          <p>撤销完成后，服务费将在1-3个工作日，</p>
          <p>退回到您的账户，请注意查收！</p>
        </div>
        <div class="authHandlerBox">
          <div
            class="button buttonActive cursorPointer"
            @click="closeDialog('contractCancelShow')"
          >取消</div>
          <div class="button cursorPointer" @click="revoke">确定</div>
        </div>
      </div>
    </Dialog>
    <div class="popUp">
      <Dialog
        :visible="dialogVisible"
        :dialogTitle="'申请律师服务'"
        v-on:closeDialog="closeDialog('dialogVisible')"
        :width="'600px'"
      >
        <div slot="dialog">
          <div class="solicitorBox">
            <solicitor
              @closeDialog="closeDialog('dialogVisible')"
              ref="multiples"
              @hintMessages="hintMessageFns"
              @closeHints="successMessageFns"
              @dialogVisible="dialogVisibleFn"
            ></solicitor>
          </div>
        </div>
      </Dialog>
      <Dialog
        :visible="successFulBox"
        :dialogTitle="'消息提示'"
        v-on:closeDialog="closeDialog('successFulBox')"
        :width="'400px'"
      >
        <div slot="dialog">
          <div class="successFulBox">操作成功</div>
        </div>
      </Dialog>
      <Dialog
        :visible="judiciaryBox"
        :dialogTitle="'申请司法鉴定'"
        v-on:closeDialog="closeDialog('judiciaryBox')"
        :width="'600px'"
      >
        <div slot="dialog" id="sfjd">
          <div class="authenticateBox">
            <p class="doingNum">
              您正在将
              <span style="color:#E88078;">1</span>个证据统一申请司法鉴定
            </p>
            <el-form
              :model="ruleFormjdc"
              :rules="rulesjdc"
              ref="ruleFormjdc"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item label="申请名称：" prop="comName">
                <el-input v-model="ruleFormjdc.comName" plcaeholder="输入要鉴定合同名称"></el-input>
              </el-form-item>
              <el-form-item label="包含证据文件：">1</el-form-item>
              <el-form-item label="机构名称：">海存科仪司法鉴定中心</el-form-item>
              <el-form-item label="机构地址：">北京市昌平区龙城北街金域国际中心B座402室</el-form-item>
              <el-form-item class="primaryBox">
                <el-button @click="cancalFn">取消</el-button>
                <el-button
                  type="primary"
                  :disabled="isSubmitIng"
                  @click="submitjdc('ruleFormjdc')"
                >确定</el-button>
              </el-form-item>
            </el-form>
            <p class="hint">申请成功后您可携带本人身份证或企业营业执照前往相应地址现场办理司法鉴定业务</p>
          </div>
        </div>
      </Dialog>
      <Dialog
        :visible="applyNotar"
        :dialogTitle="'申请公证'"
        v-on:closeDialog="closeDialog('applyNotar')"
        :width="'600px'"
      >
        <div slot="dialog">
          <div class="applyNotar">
            <apply
              @closeDialog="closeDialog('applyNotar')"
              ref="multiples"
              @hintMessage="hintMessageFn"
              @applyNotar="applyNotarFn"
              @closeHints="successMessageFn"
            ></apply>
          </div>
        </div>
      </Dialog>
      <Dialog
        :visible="hintMessage"
        :dialogTitle="'消息提示'"
        v-on:closeDialog="closeDialog('hintMessage')"
        :width="'400px'"
        class="hintMessageBox"
      >
        <div slot="dialog">
          <div class="hintMessCon">公证包名已存在</div>
        </div>
      </Dialog>
      <Dialog
        :visible="successBox"
        :dialogTitle="'消息提示'"
        v-on:closeDialog="closeDialog('successBox')"
        :width="'400px'"
        @closeHint="successMessageFn"
        class="hintMessageBox"
      >
        <div slot="dialog">
          <div class="hintMessCon">操作成功</div>
        </div>
      </Dialog>
      <Dialog
        :visible="hintMessagess"
        :dialogTitle="'消息提示'"
        v-on:closeDialog="closeDialog('hintMessagess')"
        :width="'400px'"
        class="hintMessageBox"
      >
        <div slot="dialog">
          <div class="hintMessCon">该合同已经进行过司法鉴定</div>
        </div>
      </Dialog>
      <Dialog
        :visible="hintMessages"
        :dialogTitle="'消息提示'"
        v-on:closeDialog="closeDialog('hintMessages')"
        :width="'400px'"
        class="hintMessageBox"
      >
        <div slot="dialog">
          <div class="hintMessCon">选定合同已经申请过律师服务</div>
        </div>
      </Dialog>
      <ContractTypeDialog :visible="ShowContract.isShow"
    :appendToBody="true"
    
      :dialogTitle="ShowContract.title"
      @closeDialogfq="closeContract"
      :showClose="ShowContract.showClose"
      >
      <div slot="dialog-con" class="ContractType-cons">
          <span>公证类型：</span>
          <el-radio-group v-model="ContractType">
            <!-- <el-radio-button label="0" v-if="detail.info.type==1 || detail.info.type==2 && getUserInfo.currentUserId == detail.contractUser.userId" class="ContractType-radio">合同公证</el-radio-button> -->
            <template v-if="detail.info.type==2 && getUserInfo.currentUserId != detail.contractUser.userId">
              <!-- <el-radio-button label="0" class="ContractType-radio">合同公证</el-radio-button> -->
              <el-radio-button label="1" class="ContractType-radio">赋强公证</el-radio-button>
            </template>
            <template v-if="detail.info.type==4 && detail.info.signatoryRoleCode == 'DR'">
              <el-radio-button label="2" class="ContractType-radio">调解赋强公证</el-radio-button>
            </template>
           
          </el-radio-group>
      </div>
      <div slot="dialog-btn">
          <el-button type="primary" class="closeContract" @click="closeContract">取消</el-button>
          <el-button type="primary" class="subContract" @click="goContract">下一步</el-button>
      </div>
    </ContractTypeDialog>
     <Dialog
        :visible="applyNotars"
        :dialogTitle="'赋强公证'"
       @closeDialog="closeDialogs"
        :width="'500px'"
      >
        <div slot="dialog">
          <div class="applyNotars">
            <div class="rlsbs wxapp-con">
              <p class="rlsb_desc">
                微信扫码在小程序完成赋强公证
              </p>
              <p class="rlsb_title">&nbsp;− 二维码5分钟内有效 −&nbsp;</p> 
              <div class="erweima wxappCode">
                <!-- <vue-qr id="canvass" :text="codrUrl" :size="200"></vue-qr> -->
                <img :src="codrUrl"/>
              </div>
              <div class="erweima_errro wxapperror" v-show="error_erweima && status==1">
                <p class="error_title">二维码失效</p>
                <span class="update_erweima" @click="updateEr">点击刷新</span>
              </div>
              <div class="erweima_success wxappsuccess"  v-show="status==0">
                <img src="../../../../../assets/images/userHome/wxsmcg_icon.png"/>
                <p class="success_title">扫描成功</p>
                <p class="success_desc">请在手机端完成申请公证</p>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  </div>
</template>

<script>
import BaseApi from "@lib/baseApi.js";
import Dialog from "@common/Dialog.vue";
import apply from "../../../service/components/applyNotar.vue";
import solicitor from "../../../service/components/solicitorServices.vue";
import ContractTypeDialog from "@common/contractTypeDialog.vue";
import {mapGetters} from "vuex";
export default {
  props: {
    detail: {
      type: Object,
      default: function() {
        return {
          info: {},
          signatoryList: [],
          contractUser: {}
        };
      }
    }
  },
  data() {
    return {
      multipleSelection: [],
      id: "",
      hintMessagess: false,
      hintMessages: false,
      successBox: false,
      hintMessage: false,
      dialogVisible: false,
      successFulBox: false,
      judiciaryBox: false,
      applyNotar: false,
      revokeTaskId: "",
      isSubmitIng: false,
      contractCancelShow: false,
      ruleFormjdc: {
        comName: ""
      },
      rulesjdc: {
        comName: [
          { required: true, message: "请输入申请名称", trigger: "blur" }
        ]
      },
      ShowContract:{
        isShow:false,
        title:"选择公证类型",
        showClose:true
      },
      ContractType:'1',
      applyNotars:false,
      codrUrl:"",
      status:1,//二维码状态
      codeStatus:null,//认证状态
      error_num:false,
        //二维码扫描成功
      success_erweima:false,
      //二维码失效
      error_erweima:false,
      isshowTimeEnd:false,
      text:""
    };
  },
  filters: {
    formatData(value) {
      if (value) {
        return value.slice(0, 10);
      } else {
        return "";
      }
    }
  },
  computed:{
    ...mapGetters(['getUserInfo','getCurInfo'])
  },
  components: {
    Dialog,
    solicitor,
    apply,
    ContractTypeDialog
  },
  mounted() {
    console.log(this.detail)
  },
  methods: {
    showReject() {
      this.contractCancelShow = true;
    },
    selectContract() {
      this.$router.push(`/personal/sign/selectSign?id=${this.$route.query.id}`);
    },
    selectCre() {
      this.$router.push(
        `/personal/sign/SelectCertificate?id=${this.$route.query.id}`
      );
    },
    closeDialog(flag) {
      this[flag] = false;
    },
    getTaskId(data, flag) {
      if (data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].actionCode === flag) {
            return data[i].taskId;
          }
        }
      } else {
        return "";
      }
    },
    submitjdc(formName) {
      this.isSubmitIng = true;
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.sifa();
        } else {
          this.isSubmitIng = false;
          console.log("error submit!!");
          return false;
        }
      });
    },
    sifa() {
      var params = {
        expertisePackageName: this.ruleFormjdc.comName,
        expertiseCenterCode: "1",
        expertiseCenterAddress: "北京市昌平区龙城北街金域国际中心B座402室",
        contractCount: 1,
        contractIds: this.id
      };
      const loading = this.$loading({
        lock: true,
        text: "正在提交",
        target: "#sfjd"
      });
      BaseApi.createRpcToken("/Judiciary/addJudiciary", params, "post")
        .then(
          data => {
            if (data.datas == null) {
              this.successBox = true;
             this.judiciaryBox=false;
              setTimeout(() => {
                this.successBox = false;
                this.$router.replace({
                  path: "/personal/serviceHome",
                  query: {
                    flag: "second"
                  }
                });
                this.isSubmitIng = false;
              }, 1000);
            } else if ((data.datas.code = "7001")) {
              this.judiciaryBox = false;
              this.hintMessagess = true;
              setTimeout(() => {
                this.hintMessagess = false;
                // this.judiciaryBox = true;
                this.isSubmitIng = false;
              }, 1000);
            } else {
              this.isSubmitIng = false;
            }
            loading.close();
          },
          data => {
            console.log(data);
            loading.close();
          }
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    hintMessageFns(data) {
      this.hintMessages = data;
    },
    successMessageFns(data) {
      this.successBox = data;
    },
    dialogVisibleFn(data) {
      this.dialogVisible = data;
    },
    revoke() {
      let locationInfo = this.$store.getters.getLocation;
      BaseApi.createRpcToken(
        "/contract/revoke",
        {
          id: this.$route.query.id,
          taskId: this.revokeTaskId,
          signLocation: locationInfo && locationInfo.location,
          signLocationAttr: locationInfo && locationInfo.LocationAttr
        },
        "post"
      )
        .then(data => {
          if (data.datas.success) {
            this.contractCancelShow = false;
            this.$message.success("撤销成功");
            this.$emit("getDetial");
          } else {
            this.$message.error("撤销失败");
          }
        })
        .catch(function(e) {
          errorLog(e);
        });
    },
    judgeRevoke() {
      this.revokeTaskId = this.getTaskId(this.detail.taskList, "REVOKE");
      if (this.revokeTaskId) {
        return true;
      } else {
        return false;
      }
    },
    cancalFn() {
      this.judiciaryBox = false;
    },
    hintMessageFn(data) {
      this.hintMessage = data;
    },
    successMessageFn(data) {
      this.successBox = data;
    },
    applyNotarFn(data) {
      this.applyNotar = data;
    },
    addFn(num) {
      if (num == "0") {
        this.dialogVisible = true;
        (this.multipleSelection = []), (this.id = this.$route.query.id);
        this.multipleSelection.push(this.id);
        this.$nextTick(function() {
          this.$refs.multiples.setData(this.multipleSelection);
        });
      } else if (num == "1") {
        this.judiciaryBox = true;
      } else {
        this.ShowContract.isShow = true;
        // (this.multipleSelection = []), (this.id = this.$route.query.id);
        // this.multipleSelection.push(this.id);
        // this.$nextTick(function() {
        //   this.$refs.multiples.setData(this.multipleSelection);
        // });
      }
    },
    //刷新二维码
    updateEr(){
      if(this.status==0){
        return;
      }else{
        this.error_erweima=false;
        this.addNotrats(this.detail.info)
      }
    },
    //关闭赋强公证弹框
    closeDialogs(){
      this.applyNotars=false;
    },
    closeContract(){
       this.ShowContract.isShow = false;
    },
    goContract(){
      if(this.ContractType == '0'){
        this.applyNotar=true;
        this.closeContract();
      }else{
        this.closeContract();
        //赋强公证
        this.addNotrats(this.detail.info)
      }
    },
  //实时获取二维码状态
    setTimerEr(contractId) {
      var timer=null;
      BaseApi.createRpcToken("/notaryApply/getWxUrlStatus",{contractId},"GET").then(data=>{
        if(data.code==200){
            clearTimeout(timer)
            this.status=data.datas.status;
            let self=this;
            if (self && !self._isDestroyed) {
              timer = setTimeout(() => {
                this.setTimerEr(contractId)
              }, 1000)  
            }
             if(this.isshowTimeEnd && data.datas.status!=0){
               clearTimeout(timer)
            }else
            //二维码失效
            if(this.error_erweima){
              clearTimeout(timer)
            }else if(data.datas.status==0){//扫码完成
               clearTimeout(timer)
            }
        }
      else {
          clearTimeout(timer) //清理定时任务
      }
      }, data => {
        
      })
      .catch(function (e) {
        errorLog(e);
      });
    },
    //赋强公证
    addNotrats() {
      this.$store.commit('showLoading', true)
      BaseApi.createRpcToken(
          "/notaryApply/checkCanFqNotaryApply",
          {
            contractId: this.detail.info.id,
            notaryId: 1,
          },
          "post"
      ).then(data => {
        this.$store.commit('showLoading', false)
        let timer = null;
        const endTime = new Date().getTime() + 5 * 60 * 1000;
        timer = setInterval(() => {
          const start = new Date().getTime();
          if (start > endTime) {
            this.isshowTimeEnd = true;
            this.error_erweima = true;
            clearInterval(timer)
          } else {
            if (this.status == 0) {
              clearInterval(timer)
              this.isshowTimeEnd = false;
              this.error_erweima = false;
            } else {
              this.error_erweima = false;
            }
          }
        }, 1000)
        if (data.datas.code == 200) {
          this.codrUrl = "data:image/png;base64," + data.datas.wxUrlbase64;
          this.applyNotars = true;
          this.setTimerEr(info.id);
        } else {
          this.$message.error(data.datas.message);
        }
      }).catch(function (e) {
        errorLog(e);
      });
    },
  },
  created() {
    this.id = this.$route.query.id;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.ContractBox{
    width: 520px;
    height: 262px;
    background: #FFFFFF;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    margin-top: 15% !important;
    box-sizing: border-box;
    .el-dialog__header {
  display: block;
  padding: 0px;
  border-bottom: 1px solid #E9E9E9;
  padding: 20px;
}
    .ContractType-cons{
      margin-top: 30px;
      padding:20px;
      .el-radio-button__inner{
        margin-left: 14px;
        width: auto !important;
        height: 36px;
        background: #FFFFFF;
        box-shadow: none;
        border-radius: 18px;
        border: 1px solid #D9D9D9;
        outline: none;
      }
      .el-radio-button__inner:hover{
         color: #5B5B5B;
      }
       .el-radio-button__orig-radio:checked+.el-radio-button__inner{
            background: #FFF0F0;
              border: 1px solid #D81212;
              color: #D81212;
        }
    }
  }
.signDetailList {
  position: relative;
  .signDetailDialogWithButton {
    height: 200px;
    width: 400px;
    box-sizing: border-box;
    background-color: white;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    padding: 0 20px;
    .authDscp {
      font-size: 14px;
      color: #646464;
      letter-spacing: 0;
      text-align: center;
      line-height: 20px;
      padding-top: 20px;
    }
    .withInput {
      width: 100%;
      text-align: left;
      .el-input__inner {
        width: 100%;
        height: 32px;
        line-height: 32px;
      }
    }
  }
  .signDetailMenu {
    position: absolute;
    top: 0;
    right: 0;
    li {
      float: left;
      padding: 10px;
      font-size: 12px;
      line-height: 14px;
      border: 1px solid #D81212;
      margin-left: 10px;
      color: #D81212;
      cursor: pointer;
      img {
        width: 14px;
        height: 14px;
        display: block;
        float: left;
        margin-right: 5px;
      }
      .normal {
        display: block;
      }
      .hover {
        display: none;
      }
      &:hover {
        background-color: #D81212;
        border: 1px solid #f0f0f0;
        color: white;
        .normal {
          display: none;
        }
        .hover {
          display: inline-block;
        }
      }
    }
  }
  .completeFlag {
    position: absolute;
    width: 80px;
    height: 80px;
    right: 0;
    top: 63px;
    background: url(./../../../../../assets/images/personalSignDetail/completeFlag.png);
    background-size: 100%;
  }
  div {
    line-height: 24px;
    font-size: 12px;
    color: #969696;
    .itemLabel {
      display: inline-block;
      width: 84px;
      margin-right: 20px;
      color: #e88078;
    }
    .firstContent {
      display: inline-block;
      width: 500px;
    }
    .moreNameSign {
      margin-right: 30px;
    }
    .authenticateBox {
      height: 319px;
      width: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      .el-form-item__error{
        line-height:14px;
      }
      .doingNum,
      .hint {
        width: 100%;
        text-align: center;
        height: 32px;
        line-height: 32px;
        background-color: #f0f0f0;
        font-size: 12px;
        color: #969696;
      }
      .hint {
        width: 473px;
        margin-top: 20px;
      }
      .el-form {
        .el-form-item {
          margin-bottom: 0;
          .el-form-item__label {
            font-size: 12px;
            color: #919191;
            line-height: 30px;
            padding: 0;
          }
          .el-form-item__content {
            line-height: 30px;
            .el-input {
              .el-input__inner {
                width: 170px;
                height: 30px;
                line-height: 30px;
                border-radius: 0;
                border-color: #c8c8c8;
              }
            }
            .el-button {
              width: 100px;
              height: 32px;
              line-height: 32px;
              padding: 0;
              font-size: 12px;
              background-color: #fff;
              color: #646464;
              border: 1px solid #c8c8c8;
              border-radius: 0;
            }
            .el-button--primary {
              color: #db4437;
              border-color: #db4437;
              float: left;
            }
            .el-button:nth-child(2) {
              float: right;
            }
          }
        }
        .el-form-item:nth-child(1) {
          margin-top: 27px;
          margin-bottom: 11px;
        }
        .primaryBox {
          margin-top: 20px;
          .el-form-item__content {
            margin-left: 0 !important;
          }
          .el-button:first-child:hover {
            color: #db4437;
            border-color: #db4437;
          }
          .el-button:last-child:hover {
            color: #fff;
            border-color: #a5303d;
            background-color: #a5303d;
          }
        }
      }
    }
  }
}
.hintMessageBox {
  .hintMessCon {
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.rlsbs{
  width: 100%;
  height: 300px;
  position: relative;
  .erweima_errro{
    width:160px;
    height:160px;
    background:rgba(255,255,255,0.78);
    position: absolute;
    top: 38px;
    left: 50%;
    margin-left:-80px;
    z-index: 99;
    text-align: center;
    padding-top: 60px;
    box-sizing: border-box;
    .error_title{
      font-size:16px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:600;
      color:rgba(50,50,50,1);
      margin-bottom: 12px;
    }
    .update_erweima{
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:#000;
      cursor: pointer;
    }
  }
  .erweima_success{
     width:160px;
    height:160px;
    background:rgba(255,255,255,0.78);
    position: absolute;
    top: 60px;
    left: 50%;
    margin-left:-80px;
    z-index: 99;
    text-align: center;
    padding-top: 35px;
    box-sizing: border-box;
    .success_desc{
      margin-bottom: 10px;
      margin-top: 3px;
      font-size: 13px;
    }
    .success_title{
       font-size:16px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:600;
      color:rgba(50,50,50,1);
      margin-top: -4px;
    }
     .success_update_erweima{
      font-size:14px;
      font-family:PingFangSC-Semibold,PingFang SC;
      font-weight:600;
      color:rgba(77,175,247,1);
      cursor: pointer;
    }
    img{
      opacity: 1;
    }
  }
  .rlsb_title{
    color: #1890FF;
    margin: 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    span{
      display: inline-block;
      width: 8px;
      height: 1px;
      background: #1890FF;
      border:0;
    }
  }
  .erweima{
    width: 160px;
    margin: 0 auto;
    height: 160px;
    img{
      width: 100%;
    }
  }
  .rlsb_desc{
    width: 100%;
    text-align: center;
    height: 30px;
    line-height: 30px;
    margin-top: 20px;
  }
  .success_face{
    width: 183px;
    height: 40px;
    background: #D81212;
    border: 1px solid #D81212;
    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
    display: block;
    margin: 0 auto;
  }
}
.wxapp-con{
  height: 344px !important;
}
.wxappCode{
 width: 180px !important;
 height: 180px !important;
 margin-top:40px !important; 
}
 .wxapperror {
    width: 180px !important;
    height: 180px !important;
    background: rgba(255, 255, 255, 0.78);
    position: absolute;
    top: 100px !important;
    left: 50%;
    margin-left: -90px !important;
    z-index: 99;
    text-align: center;
    padding-top: 60px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.wxappsuccess{
    width: 180px!important;
    height: 180px!important;
    background: rgba(255, 255, 255, 0.78);
    position: absolute;
    top: 97px!important;
    left: 50%;
    margin-left: -90px!important;
    z-index: 99;
    text-align: center;
    padding-top: 35px;
    box-sizing: border-box;
}
</style>
